import { scrollLock } from './ScrollLock.svelte';

export class Menu {
	public static MOBILE = 'mobile';
	public static SEARCH = 'search';

	public current = $state<string>('');
	public isMobile = $derived(this.current === Menu.MOBILE);
	public isOpen = $derived(this.current !== '' && this.current !== Menu.SEARCH);
	public isSearching = $derived(this.current === Menu.SEARCH);

	public click = (value: string | undefined) => {
		if (value && value === this.current) {
			this.current = '';
			scrollLock.unlock('menu');
		} else {
			this.current = value || '';
			if (!value) {
				scrollLock.unlock('menu');
			} else {
				scrollLock.lock('menu');
			}
		}
	};

	public close = () => {
		this.current = '';
		scrollLock.unlock('menu');
	};

	public clickMobile = () => {
		this.click(Menu.MOBILE);
	};

	public search = () => {
		this.current = Menu.SEARCH;
		scrollLock.lock('menu');
	};
}

export const menu = new Menu();
